<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>Skadar Lake National Park - Among lilies, birds and ancient walls</h1>
    <div class='tourPic'>
      <img src='@/assets/daytours/tour6/01.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>This is a tour entirely dedicated to the Skadar lake national park and the area that gravitates to it. Our intention is to spend an unforgettable day through a good mix of presentations of the cultural heritage of the area that gravitates to the lake and the natural beauties of the NP.</p>
            <p class='pasus'>On our way there will be the charming old town of Rijeka Crnojevića, once an important port and trading place on the shores of the lake, the town of Virpazar, the main starting point for boat excursions with numerous wineries in the surrounding villages, the village of Godinje, known for its architecture, wine and interesting history.</p>
            <p class='pasus'>We will enjoy a boat ride through the meanders of the Crnojevića river, now flooded with lake water, get to know the flora and fauna of the park, observe numerous birds (gray, white and yellow herons, small and large cormorants, pelicans, terns, cutes...), rest our eyes surrounded by vast areas covered with water lilies, reeds and water chestnuts, and if desired, bathe in clean water at a pleasant temperature.</p>
            <p class='pasus'>We will drive along old roads through numerous villages and enjoy spectacular views of the largest lake in the Balkans. The region that gravitates to the lake has been known since ancient times for wine production, so we won't miss the chance if you want to visit one of the local wineries.</p>
            <p class='pasus'>In the late afternoon we will be back in Podgorica.</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>Availability: March – November</p>
            <p class='pasus'>Group size – 1-7</p>
            <p class='pasus'>Departure from: Podgorica</p>
            <p class='pasus'>Difficulty level: easy</p>
            <p class='pasus'>Duration: 7-8 h</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <div class='collapse' id='itinerary'>
            <ul class='square'>
              <li class='pasus'>At 9 am we will pick you up at your place or at the place of agreement </li>
              <li class='pasus'>After about half an hour of driving, we will reach the Pavlova strana viewpoint, where we will enjoy the view of the lake meanders for about 10 minutes, and then we descend to the small, charming town of Rijeka Crnojevića, from where we set off on a boat cruise. </li>
              <li class='pasus'>After an hour's drive we will reach Virpazar, another charming town and the center of many events on the Montenegrin side of Lake Skadar </li>
              <li class='pasus'>We will walk to the old Turkish fortress and enjoy the view of different sides of the national park, and then we will go another 4-5 km on the local road to the village known for its architecture and wine - Godinje. </li>
              <li class='pasus'>In Godinje we will have the opportunity to visit a local winery and, if desired, taste a famous wine with some interesting local snacks </li>
              <li class='pasus'>Return to Podgorica in the afternoon (around 4 or 5). </li>
              <li class='pasus'> </li>
            </ul>
             <div class='tour-time'>
              <p> <i class='fas fa-clock'></i> 7-8 hours</p>
              <p> <i class='fas fa-route'></i> 90 km</p>
            </div>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices:</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>1 person – 200 EUR</li>
              <li class='pasus'>2 persons – 120 EUR p/person</li>
              <li class='pasus'>3 persons – 90 EUR p/person</li>
              <li class='pasus'>4 persons – 70 EUR p/person</li>
              <li class='pasus'>5 persons - 80 EUR p/person</li>
              <li class='pasus'>6 persons – 75 EUR p/person</li>
              <li class='pasus'>7 persons – 70 EUR p/person</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Driving by car/van</li>
              <li class='pasus'>Boat ride 1h (Skadar Lake)</li>
              <li class='pasus'>Bottle of water</li>
              <li class='pasus'>National park tickets</li>
              <li class='pasus'>Professional guiding service- English</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend always carrying a hat, sunglasses, bathing suit with you.
              </li>
              <li class='pasus'>
                We recommend buying local products - wine, honey, prosciutto and cheese in vacuum packaging, as well as authentic local souvenirs.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>Additional walks during the tour</li>
              <li class='pasus'>
                Changes in the itinerary during the tour by agreement (do not affect the price)
              </li>
              <li class='pasus'>Lunch at a local restaurant</li>
              <li class='pasus'>Visit to a local winery (wine tasting + local food – 20 eur)</li>
              <li class='pasus'>Visit to a local honey producer</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/daytours/tour6/01.jpg'),
          thumbnail: require('@/assets/daytours/tour6/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour6/02.jpg'),
          thumbnail: require('@/assets/daytours/tour6/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour6/03.jpg'),
          thumbnail: require('@/assets/daytours/tour6/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour6/04.jpg'),
          thumbnail: require('@/assets/daytours/tour6/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour6/05.jpg'),
          thumbnail: require('@/assets/daytours/tour6/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour6/06.jpg'),
          thumbnail: require('@/assets/daytours/tour6/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour6/07.jpg'),
          thumbnail: require('@/assets/daytours/tour6/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour6/08.jpg'),
          thumbnail: require('@/assets/daytours/tour6/08.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/daytours/tour6/09.jpg'),
          thumbnail: require('@/assets/daytours/tour6/09.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/DT6_SkadarLake.vue